import React, { useEffect, useState } from "react";
import ApiClient from "../../utils/ApiClient";

export default function SelectLocationMenu({ location, setLocation }) {
    const [locations, setLocations] = useState([]); // State to hold location options
    const [loading, setLoading] = useState(true); // State to handle loading

    // Fetch locations from the API when the component mounts
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                // Using ApiClient to make the POST request
                const response = await ApiClient.post("/api/sflocalinventorylocations");

                if (response?.data) {
                    setLocations(response.data); // Set fetched locations
                } else {
                    console.error("Failed to fetch locations: No data in response.");
                }
            } catch (error) {
                console.error("An error occurred while fetching locations:", error);
            } finally {
                setLoading(false); // Stop the loading spinner
            }
        };

        fetchLocations();
    }, []);

    const handleLocationChange = (e) => {
        setLocation(e.target.value);
    };

    return (
        <div className="flex flex-col w-[75px]">
            <label htmlFor="location" className="text-sm font-medium text-gray-900">
                Location
            </label>
            <select
                id="location"
                name="location"
                value={location}
                onChange={handleLocationChange}
                className="mt-1 block w-full h-[38px] rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                disabled={loading} // Disable while loading data
            >
                <option value="" disabled>
                    {loading ? "Loading..." : "Select Location"}
                </option>
                {locations.map((loc) => (
                    <option key={loc.id} value={loc.location}>
                        {loc.location}
                    </option>
                ))}
            </select>
        </div>
    );
}
